import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Settings")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Settings")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("strong", null, "Settings Coming Sooon!", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://cdn.discordapp.com/attachments/327423555899883528/941631695134814208/Fitz_Sitting_Floor_Stretching.png",
  alt: "Vector_IMG"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("strong", null, "Check out our Trailer Here!", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("strong", null, "Check out our Slide Presentation Here!", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { style: {"position":"relative","width":"100%","height":"0","padding-top":"56.2500%","padding-bottom":"48px","box-shadow":"0 2px 8px 0 rgba(63,69,81,0.16)","margin-top":"1.6em","margin-bottom":"0.9em","overflow":"hidden","border-radius":"8px","will-change":"transform"} }, [
  /*#__PURE__*/_createElementVNode("iframe", {
    loading: "lazy",
    style: {"position":"absolute","width":"100%","height":"100%","top":"0","left":"0","border":"none","padding":"0","margin":"0"},
    src: "https://www.canva.com/design/DAE4BRSacNA/view?embed",
    allowfullscreen: "allowfullscreen",
    allow: "fullscreen"
  }, "\n  ")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.canva.com/design/DAE4BRSacNA/view?utm_content=DAE4BRSacNA&utm_campaign=designshare&utm_medium=embeds&utm_source=link",
  target: "_blank",
  rel: "noopener"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_header, { collapse: "condense" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_title, { size: "large" }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_card, {
            button: true,
            a: "",
            href: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_title, null, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_thumbnail, { slot: "end" }, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_card, {
            button: true,
            a: "",
            href: "https://cdn.discordapp.com/attachments/327423555899883528/941660118985097236/2e2d06d0-8cc1-48c0-b43f-b42a9c8bab9e.mp4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_title, null, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_title, null, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _hoisted_7,
              _hoisted_8
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}